import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import CateringSidebar from 'components/CateringSidebar';
import CateringEditForm from 'components/CateringEditForm';

import { withData } from 'lib';
import { SettingsCateringEditPageQuery } from '__generated__/SettingsCateringEditPageQuery.graphql';

const query = graphql`
  query SettingsCateringEditPageQuery($id: ID!) {
    cateringOption(id: $id) {
      name
      etgKey

      ...CateringEditForm_cateringOption
      ...CateringSidebar_cateringOption
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsCateringEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/catering', name: 'Maitinimas' },
];

const SettingsCateringEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { cateringOption } = usePreloadedQuery<SettingsCateringEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!cateringOption) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<CateringSidebar cateringOption={cateringOption} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          name:
            cateringOption.name ??
            `[${cateringOption.etgKey}]` ??
            'Be pavadinimo',
        },
      ]}>
      <CateringEditForm cateringOption={cateringOption} />
    </PageWithSidebar>
  );
};

export default withData<SettingsCateringEditPageQuery, RouteParams>({
  query,
  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsCateringEditPage);
